var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        eight: "88",
        viewBox: "0 0 100 88"
      }
    },
    [
      _c("path", {
        staticClass: "cls-1",
        attrs: {
          d:
            "M92.69,0H7.31A7.31,7.31,0,0,0,0,7.31V58.69A7.31,7.31,0,0,0,7.31,66H16.5V87.5L38,66H92.69A7.31,7.31,0,0,0,100,58.69V7.31A7.31,7.31,0,0,0,92.69,0ZM17.5,14h54a2.5,2.5,0,0,1,0,5h-54a2.5,2.5,0,0,1,0-5Zm51,35h-51a2.5,2.5,0,0,1,0-5h51a2.5,2.5,0,0,1,0,5Zm12-10h-63a2.5,2.5,0,0,1,0-5h63a2.5,2.5,0,0,1,0,5Zm4-10h-67a2.5,2.5,0,0,1,0-5h67a2.5,2.5,0,0,1,0,5Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1aa41ea6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1aa41ea6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/icon-speechbubble.vue
// module id = null
// module chunks = 